import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

const throttle = (fn, wait = 120) => {
  let isThrottled = false;
  let lastArgs = null;
  let lastContext = null;

  return function throttled(...args) {
    if (isThrottled) {
      lastArgs = args;
      lastContext = this;
      return;
    }

    fn.apply(this, args);
    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;
      if (lastArgs) {
        fn.apply(lastContext, lastArgs);
        lastArgs = null;
        lastContext = null;
      }
    }, wait);
  };
};

const cleanupExtractedSlide = (slide) => {
  Array.from(slide.classList).forEach((className) => {
    if (className.startsWith('swiper-slide')) {
      slide.classList.remove(className);
    }
  });
  slide.removeAttribute('style');
  slide.removeAttribute('data-swiper-slide-index');
};

let propositionsSwiperWr = document.querySelectorAll('.propositions-swiper-wr');
propositionsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let titleSlide = wrapper.querySelector('.swiper-slide.propositions-sec__title');

    if (!titleSlide) {
      const titleEl = wrapper.querySelector('.propositions-sec__title');
      if (titleEl) {
        titleSlide = titleEl.closest('.swiper-slide');
      }
    }

    if (titleSlide) {
      const titlePlaceholder = document.createComment('propositions-title-placeholder');
      wrapper.insertBefore(titlePlaceholder, titleSlide);

      const syncTitleSlidePosition = () => {
        if (window.innerWidth < 768) {
          if (titleSlide.parentElement === wrapper) {
            el.insertBefore(titleSlide, swiperEl);
            cleanupExtractedSlide(titleSlide);
            swiperEl.swiper?.update?.();
          }
          return;
        }

        if (titleSlide.parentElement !== wrapper) {
          titleSlide.classList.add('swiper-slide');
          titleSlide.removeAttribute('style');
          if (titlePlaceholder.parentElement === wrapper) {
            wrapper.insertBefore(titleSlide, titlePlaceholder);
          } else {
            wrapper.appendChild(titleSlide);
          }
          swiperEl.swiper?.update?.();
        }
      };

      const throttledSyncTitleSlidePosition = throttle(syncTitleSlidePosition);
      throttledSyncTitleSlidePosition();
      window.addEventListener('resize', throttledSyncTitleSlidePosition);
    }

    swiperOnResize('(max-width: 768px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        breakpoints: {
          400: {
            spaceBetween: 16,
            slidesPerView: 1.2,
          },
          480: {
            spaceBetween: 16,
            slidesPerView: 1.5,
          },
          600: {
            spaceBetween: 18,
            slidesPerView: 2,
          },
        },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        },
    );
  }
});
